import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';

export const setAllAttendeesSearch = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<string>((state, action) => {
    state.allAttendees.search = action.payload;
    state.allAttendees.page = 1;
  });
